import PitchResultCombined from '../PitchResultCombined.js';

// @see https://flightscope.atlassian.net/browse/BBP-691?focusedCommentId=45443
const PitchResultCombinedGroup = {
    BaseHits: { key: 'BaseHits', name: 'Base hits', results: [
        PitchResultCombined.Single.key,
        PitchResultCombined.Double.key,
        PitchResultCombined.Triple.key,
        PitchResultCombined.HomeRun.key,
        PitchResultCombined.InsideTheParkHomeRun.key,
        PitchResultCombined.GroundRuleDouble.key,
    ]},
    BatterSafe: { key: 'BatterSafe', name: 'Batter safe', results: [
        PitchResultCombined.Walk.key,
        PitchResultCombined.IntentionalWalk.key,
        PitchResultCombined.HitByPitch.key,
        PitchResultCombined.ReachedOnError.key,
        PitchResultCombined.FieldersChoice.key,
        PitchResultCombined.CatcherInterference.key,
        PitchResultCombined.WildPitch.key,
        PitchResultCombined.PassedBall.key,
        PitchResultCombined.SacrificeOnError.key,
        PitchResultCombined.SacrificeOnFieldersChoice.key,
    ]},
    BatterOut: { key: 'BatterOut', name: 'Batter out', results: [
        PitchResultCombined.FieldOut.key,
        PitchResultCombined.SwingingStrikeout.key,
        PitchResultCombined.CalledStrikeout.key,
        PitchResultCombined.SacrificeFly.key,
        PitchResultCombined.SacrificeBunt.key,
        PitchResultCombined.SacrificePlay.key,
        PitchResultCombined.InfieldFly.key,
        PitchResultCombined.BatterInterference.key,
        PitchResultCombined.FoulTipOut.key,
        PitchResultCombined.FoulOut.key,
        PitchResultCombined.BatterOut.key,
    ]},
    NoResult: { key: 'NoResult', name: 'No result', results: [
        PitchResultCombined.Ball.key,
        PitchResultCombined.IntentionalBall.key,
        PitchResultCombined.SwingingStrike.key,
        PitchResultCombined.CalledStrike.key,
        PitchResultCombined.FoulBall.key,
        PitchResultCombined.IllegalPitch.key,
        PitchResultCombined.Balk.key,
        PitchResultCombined.PitchOut.key,
        PitchResultCombined.NoPitch.key,
    ]},
};

export default PitchResultCombinedGroup;